module.exports = __webpack_public_path__ + "img/Gauge-True_Wind-Plate_img01.aeae89de.svg";